import Vue from "vue";
import VueRouter from "vue-router";
import Component from "vue-class-component";

Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteUpdate",
    "beforeRouteLeave"
]);

import Login from "@/views/login/Login.vue";
import Home from "@/views/home/Home.vue";
import InspectionsList from "@/views/inspection/InspectionsList.vue";
import Changelog from "@/views/changelog/app.vue";
import Inspection from "@/views/inspection/Inspection.vue";
import imagensSuporte from "@/views/imagensSuporte/imagensSuporte.vue";
import Transmission from "@/views/transmission/Transmission.vue";

import Data from "@/views/inspection/stages/Data.vue";
import Quiz from "@/views/inspection/stages/Quiz.vue";
import InspectorSignature from "@/views/inspection/stages/InspectorSignature.vue";
import ClientSignature from "@/views/inspection/stages/ClientSignature.vue";
import PhotosGrid from "@/views/inspection/stages/PhotosGrid.vue";
import TakePhoto from "@/components/inspection/photos/TakePhoto.vue";
import EditPhoto from "@/components/inspection/photos/EditPhoto.vue";
import SaveInspection from "@/views/inspection/stages/SaveInspection.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: { transition: "slide-left" },
    },
    {
        path: "/home",
        alias: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/inspectionsList",
        component: InspectionsList,
    },
    {
        path: "/changelog",
        component: Changelog,
    },
    {
        path: "/inspection",
        redirect: "/inspection/data",
        component: Inspection,
        children: [
            {
                path: "data",
                component: Data
            },
            {
                path: "quiz",
                component: Quiz
            },
            {
                path: "inspector-signature",
                component: InspectorSignature
            },
            {
                path: "client-signature",
                component: ClientSignature
            },
            {
                path: "photos-grid",
                name: "photosGrid",
                props: (route) => ({
                    takenPhoto: route.params.takenPhoto,
                }),
                component: PhotosGrid
            },
            {
                path: "save-inspection",
                component: SaveInspection
            },
            {
                path: "camera",
                name: "camera",
                props: (route) => ({
                    photoData: route.params.photoData,
                }),
                component: TakePhoto,
            },
            {
                path: "edit-photo",
                name: "editPhoto",
                props: (route) => ({
                    photo: route.params.photo,
                }),
                component: EditPhoto,
            }
        ]
    },
    {
        path: "/imagens",
        component: imagensSuporte,
    },
    {
        path: "/transmission",
        component: Transmission,
    },
];

const router = new VueRouter({
    routes,
});

router.beforeEach((to, from, next) => {
    let isAuthenticated;
    if (localStorage.getItem("enterprise") && localStorage.getItem("operations")) {
        isAuthenticated = true;
    } else {
        isAuthenticated = false;
    }
    if (to.name !== "Login" && !isAuthenticated){
        localStorage.clear();
        next({ name: "Login" });
    } else if (to.name === "Login" && isAuthenticated) {
        next({ name: "Home" });
    } else {
        next();
    }
});

export default router;
